export default __webpack_public_path__ + "static/media/link_blue.7e7b7e9c.svg";